<div class="period-management-container">
    <div class="period-header">
        <div class="header-left">
            <img src="assets/images/icons/dashboard/calendar_top_red.png" alt="Calendar" class="period-icon">
            <span class="header-title">
                <span class="title-text">Gestion des Périodes</span>
            </span>
        </div>

        <div class="header-right">
            <button *ngIf="topAgents.length > 0" class="close-period-btn" (click)="closeCurrentPeriod()" [disabled]="isClosing">
                <img src="assets/images/icons/calendar_check.png" alt="Close Period" class="close-icon">
                <span>{{ isClosing ? 'Fermeture en cours...' : 'Clôturer la période' }}</span>
            </button>
        </div>
    </div>

    <div class="stats-cards">
        <div class="stat-card">
            <div class="stat-icon">
                <em class="fa fa-trophy trophy-red"></em>
            </div>
            <div class="stat-content">
                <div class="stat-value">{{ topAgents[0]?.currentPeriodPoints || 0 }}</div>
                <div class="stat-label">Points du meilleur agent</div>
            </div>
        </div>

        <div class="stat-card">
            <div class="stat-icon">
                <img src="assets/images/icons/dashboard/user_card_red.png" alt="Agents">
            </div>
            <div class="stat-content">
                <div class="stat-value">{{ topAgents.length }}</div>
                <div class="stat-label">Agents classés</div>
            </div>
        </div>

        <div class="stat-card">
            <div class="stat-icon">
                <img src="assets/images/icons/calendar.png" alt="Month">
            </div>
            <div class="stat-content">
                <div class="stat-value">{{ currentMonth }}</div>
                <div class="stat-label">Période en cours</div>
            </div>
        </div>
    </div>

    <div class="top-agents-section">
        <div *ngIf="topAgents.length > 0" class="section-header">
            <h3>Top Agents du Mois</h3>
            <span class="subtitle">Classement basé sur les points des feedbacks</span>
        </div>

        @if(isLoading) {
        <div class="loading-state">
            <div class="loading-spinner"></div>
            <p>Chargement du classement...</p>
        </div>
        } @if(!isLoading && topAgents.length === 0) {
        <div class="empty-state">
            <p>Aucun agent n'a encore de points ce mois-ci</p>
            <span class="empty-subtitle">Les points sont attribués via les feedbacks clients</span>
        </div>
        } @if(!isLoading && topAgents.length > 0) {
        <div class="agents-ranking">
            @for(agent of topAgents; track agent.id; let i = $index) {
            <div class="agent-rank-card" [class.top-three]="i < 3">
                <div class="rank-badge">
                    @if(i === 0) {
                    <em class="fa fa-trophy" style="color: gold;"></em> } @else if(i === 1) {
                    <em class="fa fa-trophy" style="color: silver;"></em> } @else if(i === 2) {
                    <em class="fa fa-trophy" style="color: bronze;"></em> } @else {
                    <span class="rank-number">{{ i + 1 }}</span> }
                </div>

                <div class="agent-image-container">
                    @if(agent.profileImage) {
                    <img [src]="agent.profileImage" [alt]="agent.firstName" class="img-fluid"> } @else {
                    <img *ngIf="!agent.profileImage" src="./assets/images/icons/user-default-icon.png" alt="agent default"> }
                </div>

                <div class="agent-info">
                    <div class="agent-name">{{ agent.firstName }} {{ agent.lastName }}</div>
                    <div class="agent-specialization">{{ agent.specialization }}</div>
                    <div class="agent-email">{{ agent.email }}</div>
                </div>

                <div class="agent-stats">
                    <div class="stat-item">
                        <span class="stat-label">Points:</span>
                        <span class="stat-value points">{{ agent.currentPeriodPoints }}</span>
                    </div>
                    @if(agent.rating){
                    <div class="stat-item">
                        <span class="stat-label">Rating:</span>
                        <span class="stat-value rating">{{ agent.rating.toFixed(1) || '0.0' }}</span>
                    </div>}
                    <div class="stat-item">
                        <span class="stat-label">Missions:</span>
                        <span class="stat-value">{{ agent.completedAssignments }}</span>
                    </div>
                </div>

                <div class="agent-awards">
                    <em class="fa fa-award" style="color: gold;"></em>
                    <span class="award-count">{{ agent.awardsCount || 0 }}</span>
                </div>
            </div>
            }
        </div>
        }
    </div>

    @if(showConfirmationModal && topAgents.length > 0) {
    <div class="modal-overlay" (click)="closeModal($event)">
        <div class="modal-content">
            <div class="modal-header">
                <h3>Clôturer la période</h3>
                <button class="close-modal" (click)="closeModal($event)">×</button>
            </div>

            <div class="modal-body">
                <p>Êtes-vous sûr de vouloir clôturer la période courante ?</p>
                <ul class="warning-list">
                    <li> Le classement final sera enregistré</li>
                    <li> Les points de tous les agents seront réinitialisés</li>
                    <li> Une nouvelle période commencera immédiatement</li>
                    <li> Cette action ne peut pas être annulée</li>
                </ul>

                @if(topAgents[0]) {
                <div class="current-top-agent">
                    <h4>Meilleur agent actuel:</h4>
                    <div class="top-agent-info">
                        <strong>{{ topAgents[0].firstName }} {{ topAgents[0].lastName }}</strong>
                        <span>avec {{ topAgents[0].currentPeriodPoints }} points</span>
                    </div>
                </div>
                }
            </div>

            <div class="modal-footer">
                <button class="cancel-btn" (click)="closeModal($event)">Annuler</button>
                <button class="delete-confirm-btn" (click)="confirmClosePeriod()" [disabled]="isClosing">
            {{ isClosing ? 'Clôture en cours...' : 'Confirmer la clôture' }}
          </button>
            </div>
        </div>
    </div>
    }
</div>